<div
  role="alert"
  class="bewp-toast-container"
  *ngIf="{ isMobileWidth: isMobileWidth$ | async } as vm"
>
  <div class="bewp-toast-container__inner">
    <app-toast-notification
      *ngFor="let toast of toasts$ | async"
      [@toastAnimationMobile]="vm.isMobileWidth ? 'visible' : 'void'"
      [@toastAnimationDesktop]="!vm.isMobileWidth ? 'visible' : 'void'"
      [toast]="toast"
      (removeToast)="removeToast($event)"
    >
    </app-toast-notification>
  </div>
</div>
